// src/hooks/useMetricsCatalog.ts
import { useQuery } from "@tanstack/react-query";
import { fetchMetricsCatalog } from "@/services/metrics";
import type { MetricInfo } from "@/types/metrics";

export const metricsQueryKeys = {
  all: ["metricsCatalog"] as const,
  list: () => [...metricsQueryKeys.all, "list"] as const,
} as const;

export function useMetricsCatalog() {
  return useQuery<MetricInfo[]>({
    queryKey: metricsQueryKeys.list(),
    queryFn: ({ signal }) => fetchMetricsCatalog(signal),
    staleTime: 5 * 60 * 1000,
  });
}


